import './growth.scss';

export default () => {

};
